module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/awesome-typescript-loader/dist/entry.js!./member-stories.ts"));
	}, "members-async-member-stories");
}